export default __webpack_public_path__ + "static/media/adamHeadshot.2e5c26e6.svg";